
function NotFound() {
  return (
    <div>
      nada foi encontrado
    </div>
  );
}
export default NotFound;
